<div fxLayout="column" class="dialog-container">
    <h1 mat-dialog-title>Liquitics Documentation & Guides</h1>
    <div mat-dialog-content fxFlex="10 1 auto" class="dialog-content">
        <p-table #rit fxFlex="1 1 auto" [value]="registryItems" [loading]="loading" [(selection)]="selectedRegistryItem"
            [globalFilterFields]="['displayName','description','type', 'tagsAsString']" dataKey="key"
            [scrollable]="true" scrollHeight="flex" [style.height]="'70vh'">
            <ng-template pTemplate="caption">
                <div class="p-d-flex">
                    <span class="p-input-icon-left p-ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="rit.filterGlobal($event.target.value, 'contains')"
                            placeholder="Search keyword" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 10vw; text-align: 'center'">Name</th>
                    <th style="width: 30vw; text-align: 'center'">Description</th>
                    <th style="width: 10vw; text-align: 'center'">Type</th>
                    <th style="width: 10vw; text-align: 'center'"> </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td style="width: 10vw; text-align: 'center'">{{item.displayName}}</td>
                    <td style="width: 30vw; text-align: 'center'">{{item.description}}</td>
                    <td style="width: 10vw; text-align: 'center'">
                        <span [class]="'status-badge item-type-' + item.type">{{item.type}}</span>
                    </td>
                    <td style="width: 10vw; text-align: 'center'" fxLayoutGap="10px">
                        <button *ngIf="item.type === 'VIDEO'" pButton pRipple icon="pi pi-video"
                            class="p-button-rounded p-button-outlined p-button-info"
                            (click)="onShowVideo(item)"></button>
                        <!-- <button *ngIf="item.type === 'DOCUMENT'" pButton pRipple icon="pi pi-download"
                            class="p-button-rounded p-button-outlined p-button-info"
                            (click)="onDownloadDocument(item)"></button> -->
                        <div *ngIf="item.type === 'DOCUMENT'" max-width="100%" max-height="100%">
                            <a [href]="item.downloadUrl" target="_blank" class="download-link"
                                [download]="item.displayName">
                                <i class="p-button-rounded p-button-outlined p-button-icon-only p-button-info p-button p-button-icon pi pi-external-link"></i>
                            </a>
                        </div>


                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div fxFlex="1 1 auto"></div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close>Close</button>
    </div>
</div>
<p-dialog header="Video" [(visible)]="videoURL" [style]="{width: '75vw', height: '75vh'}">
    <ng-template pTemplate="body">
        <div fxLayout="row">
            <video *ngIf="videoURL" fxFlex="1 1 60%" width="60%" controls>
                <source [src]="videoURL" type="video/mp4">
            </video>
            <div fxFlex="1 1 40%" fxLayout="column" class="video-details">
                <h3>{{selectedRegistryItem.displayName}}</h3>
                <p>{{selectedRegistryItem.description}}</p>
                <ul>
                    <li *ngFor="let t of selectedRegistryItem.tags">{{t}}</li>
                </ul>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="videoURL=undefined" label="Close" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>